import React from "react";
import Svg, { Path, G, Defs, Rect, ClipPath } from "react-native-svg";
import { TouchableOpacity } from "react-native";

import { isWeb } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import appStyles from "../../../appStyles";

export default function SearchIcon(props) {
  return (
    <TouchableOpacity style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_search)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.51155 9.7433C6.06696 7.95533 7.96664 6.95615 9.75461 7.51156C11.5426 8.06697 12.5418 9.96665 11.9863 11.7546C11.8614 12.1567 11.6685 12.519 11.4242 12.8326C11.373 12.8866 11.3247 12.9443 11.2799 13.0056C10.4225 13.9659 9.05294 14.3932 7.74329 13.9864C5.95532 13.4309 4.95614 11.5313 5.51155 9.7433ZM13.0089 16.2916C11.2689 17.6266 8.92907 18.1244 6.67533 17.4243C2.98864 16.2791 0.928377 12.362 2.0736 8.67534C3.21883 4.98865 7.13587 2.92839 10.8226 4.07361C14.5093 5.21884 16.5695 9.13588 15.4243 12.8226C15.3628 13.0205 15.2933 13.2137 15.2163 13.402L21.974 17.1918C22.8411 17.678 23.1498 18.7751 22.6635 19.6422C22.1773 20.5093 21.0802 20.818 20.2131 20.3317L13.0089 16.2916Z"
            fill={AppTheme.DEFAULT_COLOR}
          />
        </G>
        {isWeb ? (
          <Defs>
            <ClipPath id="clip0_search">
              <Rect width="24" height="24" fill="white" />
            </ClipPath>
          </Defs>
        ) : null}
      </Svg>
    </TouchableOpacity>
  );
}
